import {MapView} from '../MapView'
import {useCallback, useContext, useMemo} from 'react'
import {DataContext} from '../../context/DataContext'
import {getLayer, getLayers} from '../MapLayers/Layer'
import {FilterContext} from '../../context/FilterContext'
import {AllGeoJSON} from '@turf/turf'
import {Legenda} from '../Legenda'
import CheckServices from '../CheckServices'
import {HeaderPerformance} from '../Common/HeaderPerformance'
import {formatNumber} from '../../../../components/util'

type Props = {
  label?: string
}

const layerNames = ['view_ibge_explorer_renda_mensal_domiciliar']

export function PerformanceSocioDemografico({label}: Props) {
  const {data} = useContext(DataContext)
  const {geometriaSelecionada, endereco} = useContext(FilterContext)
  const renderRendaTooltip = useCallback((object) => {
    const properties = object?.properties || object
    const renda = Number(properties?.renda_mensal_domiciliar)

    if (!Number.isFinite(renda)) {
      return null
    }

    return (
      <>
        <strong>Renda mensal domiciliar</strong>
        <div>{formatNumber(renda, 'currency_inteiro')}</div>
      </>
    )
  }, [])

  // const geometryKey = JSON.stringify(geometriaSelecionada.geometry)
  const layersList = useMemo(() => {
    if (geometriaSelecionada) {
      const json = geometriaSelecionada.geometry as AllGeoJSON
      return getLayers(layerNames, json)
    } else {
      return []
    }
  }, [geometriaSelecionada])

  // if (!data) {
  //   return <>Carregando...</>
  // }

  // console.log('geometriaSelecionada')
  // console.log(geometriaSelecionada)
  // if (!geometriaSelecionada?.geometry && !geometriaSelecionada?.geometry) {
  //   return <>asdasdas</>
  // }
  if (!geometriaSelecionada) {
    return <>.</>
  }
  let geometriaSelecionadaShow = null
  if (geometriaSelecionada?.type === 'Feature') {
    geometriaSelecionadaShow = geometriaSelecionada.geometry
  } else {
    geometriaSelecionadaShow = geometriaSelecionada
  }

  //  geometria.type === 'Polygon' || geometria.type === 'MultiPolygon'
  //             ? geometria.coordinates[0]
  //             : geometria.geometry.coordinates[0]

  const layerConfig = getLayer('view_ibge_explorer_renda_mensal_domiciliar')
  let center = {
    lat: -46.6,
    lng: -23.6,
  }
  if (endereco) {
    center = {lat: endereco.latitude, lng: endereco.longitude}
  }

  return (
    <>
      <div className=' d-flex flex-column justify-content-start p-10'>
        <HeaderPerformance titulo={'Sóciodemográfico'}></HeaderPerformance>
        <div className='content pt-5'>
          <div className='row'>
            <div className='col-12'>
              <div className='card bgi-no-repeat card-xl-stretch mb-xl-8 border-2 box-performance'>
                <div className='map-painel d-flex w-100'>
                  <div className='mapa col-6'>
                    <MapView
                      data={data}
                      layer={layersList}
                      layerTooltip={renderRendaTooltip}
                      height={'650px'}
                      zoom={15}
                      center={center}
                      geometria={geometriaSelecionadaShow}
                    >
                      <Legenda style={layerConfig.style} title={'Renda'} visivel={true}></Legenda>
                    </MapView>
                  </div>
                  <div className='painel-lateral col-6 px-5'>
                    <CheckServices onChange={undefined}></CheckServices>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
